<template>
    <div>
        <el-tabs v-model="activeTab">

            <el-tab-pane label="详情" name="detail">
                <el-form :inline="true" label-width="68px" class="searchListInput">
                    <el-form-item class="mb8">
                        <el-button type="primary" icon="el-icon-finished" size="mini" @click="save"
                                   class="elButtonSearch">保存
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-form
                        ref="form"
                        :model="form"
                        :rules="rules"
                        label-width="100px"
                >
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="原密码" prop="oldPassword">
                                <el-input
                                        v-model="form.oldPassword"
                                        placeholder="原密码"
                                        show-password
                                />
                            </el-form-item>
                            <el-form-item label="新密码" prop="newPassword">
                                <el-input
                                        v-model="form.newPassword"
                                        placeholder="新密码"
                                        show-password
                                />
                            </el-form-item>
                            <el-form-item label="确认新密码" prop="confirmNewPassword">
                                <el-input
                                        v-model="form.confirmNewPassword"
                                        placeholder="确认新密码"
                                        show-password
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {updatePassword} from '../../api/system/basicUser'
    export default {
        name: "Spring",
        data() {
            return {
                activeTab: 'detail',
                // 遮罩层
                loading: true,

                // 表单参数
                form: {},
                // 表单校验
                rules: {
                    oldPassword: [
                        {required: true, message: "原密码不能为空", trigger: "blur"}
                    ],
                    newPassword: [
                        {required: true, message: "新密码不能为空", trigger: "blur"}
                    ],
                    confirmNewPassword: [
                        {required: true, message: "确认新密码不能为空", trigger: "blur"}
                    ],
                }
            }
        },

        created() {
        },

        methods: {

            async save() {
                await updatePassword(this.form).then();
                this.msgSuccess("保存成功")
            },

        },
    }
</script>

<style scoped lang="scss">
 .el-tabs {
  padding: 0 10px;
  height: 100%;
  .el-tab-pane {
    height: calc(100% - 75px);
  }
}
  .elButtonSearch {
        background: var(--buttonColor);
        border: 1px solid var(--buttonColor);

        &:hover {
            background: var(--buttonActiveColor);
            border: 1px solid var(--buttonActiveColor);
        }
    }

    .searchListInput {
        .el-input__inner {
            &::placeholder {
                color: #838689;
            }
        }

        .el-date-editor .el-range-input {
            &::placeholder {
                color: #838689
            }
        }

        .el-form-item {
            margin-bottom: 0.25rem;
        }
    }

    .rg_bottom {
        border-bottom: 1px solid #D8DCE4;
        border-left: 1px solid #D8DCE4;
        border-right: 1px solid #D8DCE4;
        height: 0.45rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0.15rem;
    }
</style>
